<template>
<div class="kpi-container">
    <MonthKpiSummary :selectedMonth="selectedMonth" @animationDone="onAnimationDone"/>

<!--    <h2 class="globalHeader">Monatliche Wachstumsprämie</h2>-->
<!--    <MonthKPIRecruiting :selectedMonth="selectedMonth"/>-->

    <h2 class="globalHeaderWithSubHeader">Jahresüberschuss</h2>
    <h4 class="globalHeaderWithSubHeader">aller Fachkräfte bei <b style="color:var(--ion-color-superblack-tint)">ines</b></h4>
    <MonthKpiCompany :selectedMonth="selectedMonth"/>

    <IonButton :color="'primary'" @click="showExcessDetailModal = true" class="margin-top-regular">Wie ergibt sich mein Jahresüberschuss?</IonButton>

    <h2 class="globalHeader">Urlaubsanspruch</h2>
    <MonthKPIVacation :selectedMonth="selectedMonth"/>

    <h2 class="globalHeader">Arbeitszeitkonto (AZK)</h2>
    <MonthKPIAZK :selectedMonth="selectedMonth"/>
</div>

<Modal v-model="showExcessDetailModal" :title="'Wie ergibt sich mein Anteil?'">
    <MonthKPIExcessDetails :selected-month="props.selectedMonth"/>
</Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue'
import {IonButton, IonIcon, IonLabel} from '@ionic/vue';
import {computed, PropType, ref, Ref, watch} from 'vue';
import {generateCalendarMonth} from "@/helper/calendar/calendarMonth";
import date from "@/helper/datetime/date";

import {fetchPlanningTemplate, getWorktimeMode, updateAutopilotPreference} from "@/helper/autopilotPreference";
import {DataLoader} from "@/helper/dataLoader";

import Skeleton from "@/components/Skeleton.vue";
import {floatFormat, pluralize, pluralizeUnitOnly} from '@/helper/amountFormatter';
import {
    Absence,
    AbsenceType,
    AutopilotPreference,
    AutopilotStatus,
    Day, PayrollStatus,
    PlanningTemplate
} from "@/graphql/generated/graphql";
import {fetchAutopilotStatus, fetchSpotOnBookingTarget} from "@/helper/autopilotStatus";

import {kapitelDateString, kapitelMonthString} from '@/graphql/kapitelTypes';
import PlusMinusInput from "@/components/PlusMinusInput.vue";
import MonthCalendarLegend from "@/components/MonthCalendarLegend.vue";
import {DayMap, fetchDaysForMonth, generateDay, toDayMap} from "@/helper/day";
import {generateAbsence, getLabelForAbsenceType, removeAbsence, setAbsence} from "@/helper/absence";
import {useEmployeeStore} from "@/store/employee";
import MonthCalendarGrid from "@/components/MonthCalendarGrid.vue";
import Contact from "@/views/CalendarDetail/components/Contact.vue";
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import {getImageForJobsite} from "@/helper/jobsite";
import {getLabelForShift} from "../../../helper/shiftTypes";
import datetime from "@/helper/datetime/datetime";
import WorktimeSummaryLine from "@/views/components/Planning/WorktimeSummaryLine.vue";
import {informationCircle} from "ionicons/icons";
import {consoleLog} from "@/helper/console";
import CalendarDetail from "@/views/CalendarDetail/CalendarDetail.vue";
import AbsenceBubble from "@/components/AbsenceBubble.vue";
import AInesMostRecentMessage from "@/views/Chat/AInesMostRecentMessage.vue";
import MonthKpiRevenueAndExcessContribution from "@/views/components/MonthKPI/section/MonthKPIRevenueAndExcessContribution.vue";
import MonthKPIProductivity from "@/views/components/MonthKPI/section/MonthKPIProductivity.vue";
import MonthKpiCompany from "@/views/components/MonthKPI/section/MonthKPICompany.vue";
import MonthKPIRecruiting from "@/views/components/MonthKPI/section/MonthKPIRecruiting.vue";
import MonthKPIVacation from "@/views/components/MonthKPI/section/MonthKPIVacation.vue";
import MonthKPIAZK from "@/views/components/MonthKPI/section/MonthKPIAZK.vue";
import MonthKpiPlanningSummary from "@/views/components/MonthKPI/section/MonthKPIPlanningSummary.vue";
import MonthKpiSummary from "@/views/components/MonthKPI/section/MonthKPISummary.vue";
import DetailsPopover from "@/views/components/DetailsPopover.vue";
import month from "@/helper/datetime/month";
import {
    fetchPayrollStatusForMonth,
    setPayrollStatusSeen
} from "@/helper/monthKPI/monthKpiPayroll";
import money from "@/helper/money";
import {useAppState} from "@/helper/appState";
import {useAuthStore} from "@/store/auth";
import {isMostRecentPublishedMonth} from "@/helper/monthKPI/monthKPI";
import MonthKPIExcessDetails from "@/views/components/MonthKPI/MonthKPIExcessDetails.vue";

const props = defineProps({
    selectedMonth: {
        type: String as PropType<kapitelMonthString>,
        required: true,
    }
});

const showExcessDetailModal = ref(false)

// loader
const initialDataLoader = new DataLoader();

const payrollStatusForMonth : Ref<PayrollStatus | undefined> = ref(undefined);
initialDataLoader.add(async () => payrollStatusForMonth.value = await fetchPayrollStatusForMonth(props.selectedMonth))

initialDataLoader.load()

// animation
const onAnimationDone = () => {
    if (!payrollStatusForMonth.value) {
        return
    }
    if (useAuthStore().isImpersonating()) {
        console.info("skipping setSeen because of impersonation")
        return
    }
    setPayrollStatusSeen(payrollStatusForMonth.value.month as kapitelMonthString)
}

</script>

<style lang="scss" scoped>
.kpi-container {
    display: flex;
    flex-direction: column;
}
</style>
